import { SignUpForm } from "@features/sign-up";

export const RegisterPage = () => <SignUpForm />;
